<template>
    <div
        :class="{
            'l-ss-c-filter-is-short': isShort,
            'l-ss-c-filter-toggle-is-checked': isChecked(option.id),
        }"
        class="l-ss-c-filter-toggle"
        @click="onToggle">
        <span class="l-ss-c-filter-toggle-icon"></span>
        <c-label :label="option.name"/>
    </div>
</template>

<script>
    import FilterMixin from './mixin';
    import CLabel from './components/label';

    const MIN_ITEMS_COUNT_FOR_SHOW_MORE = 3;

    export default {
        components: {
            CLabel,
        },
        mixins: [
            FilterMixin,
        ],
        props: {},
        data() {
            return {
                values: [],
                showMore: false,
            };
        },
        computed: {
            inputType() {
                return 'checkbox';
            },
            hasShowMore() {
                return !this.forceShowAll && this.filter.options.length >= MIN_ITEMS_COUNT_FOR_SHOW_MORE;
            },
            options() {
                return this.filter.options;
            },
            option() {
                return this.options ? this.options[0] : { id: null };
            },
        },
        watch: {
            filterValue: {
                immediate: true,
                handler(value) {
                    this.values = value && value.options ?
                        value.options.slice().filter((item, index, values) => values.indexOf(item) === index) :
                        [];
                },
            },
        },
        mounted() {
            const options = this.options;
            if (this.values.length && !this.values.every(optionId => options.find(item => item.id === optionId))) {
                this.showMore = true;
            }
        },
        methods: {
            isChecked(optionId) {
                return this.values.includes(optionId);
            },
            onToggle() {
                const checked = this.isChecked(this.option.id);
                const value = this.option.id;
                const values = this.values.slice();
                if (checked) {
                    if (values.includes(value)) {
                        values.splice(values.indexOf(value), 1);
                    }
                } else {
                    values.push(value);
                }
                this.values = values.slice();
                if (values.length) {
                    this.onChange({
                        condition: 'in',
                        options: values.slice(),
                    });
                } else {
                    this.onChange();
                }
            },
        },
    };
</script>